import { buttonClass, isActiveButtonClass } from '@/modules/Dashboard/Audience/Audience';

interface TabMenuProps {
  tabLabels: string[];
  changeActiveStep: (step: string) => void;
  activeStep: string;
}

const TabMenu: React.FC<TabMenuProps> = ({ tabLabels, activeStep, changeActiveStep }) => {
  return (
    <div className="sticky z-10 top-0 pt-4 flex items-end mb-6 bg-white after:absolute after:left-[-2rem] after:bottom-[-1px] after:w-[calc(100%+4rem)] after:border-b after:border-custom-lightSilver before:absolute before:left-[-2rem] before:-top-4 before:w-[calc(100%+4rem)] before:border-b before:border-custom-lightSilver before:h-4 before:bg-white">
      {tabLabels.map((tabLabel, index) => (
        <button
          key={tabLabel + index}
          className={`${buttonClass} ${activeStep === tabLabel && isActiveButtonClass}`}
          onClick={() => changeActiveStep(tabLabel)}
        >
          {tabLabel}
        </button>
      ))}
    </div>
  );
};

export default TabMenu;
